import { useEffect } from "react";
import { useSite, tx } from "@/lib/lang";
import Nav from "@/components/site/Nav";
import { legalContent } from "@/lib/legalContent";

export default function LegalPage({ type }) {
  const { content, lang } = useSite();
  const doc = content.legal?.[type] || legalContent[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-onyx text-ice pt-20">
      <Nav />

      <main data-testid={`${type}-page`} className="mx-auto max-w-4xl px-6 py-16 lg:py-20">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-azure">{tx(doc.label, lang)}</p>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-ice">{tx(doc.title, lang)}</h1>
        <p className="mt-3 font-mono text-xs text-muted-foreground">{tx(doc.updated, lang)}</p>

        <div className="mt-12 space-y-10">
          {doc.sections.map((s, i) => (
            <section key={i} className="border-t border-ice/8 pt-8">
              <h2 className="font-display text-lg font-semibold text-ice">{tx(s.heading, lang)}</h2>
              {(s.paragraphs || []).map((p, j) => (
                <p key={j} className="mt-3 text-sm text-muted-foreground leading-relaxed">
                  {tx(p, lang)}
                </p>
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2.5">
                  {s.list.map((li, k) => (
                    <li key={k} className="flex items-start gap-3 text-sm text-muted-foreground leading-relaxed">
                      <span className="mt-[8px] h-1 w-3 rounded-full bg-royal/60 shrink-0" />
                      {tx(li, lang)}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-ice/5">
        <div className="mx-auto max-w-4xl px-6 py-6">
          <p className="font-mono text-xs text-muted-foreground/60">
            © {new Date().getFullYear()} RR Solutions srl — ETHIC ENERGY · P.IVA 02582720997
          </p>
        </div>
      </footer>
    </div>
  );
}
